module.exports = __webpack_public_path__ + "img/44.65464eea.jpg";